import { Chip } from '@mui/material'
import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom'
import PriceFormat from '../../actions/PriceFormat'
import GetCourses from "../../actions/GetCourses";

const InternshipItem = ({ internship, index }) => {

     const hasCategory = internship.category && internship.category.length > 0;

     return (
          <div
               className={`p-4 mt-4 mb-4 internship-card border-0 bg-white w-100 fade-in-bottom delay-${index}s rounded-3 shadow-lg`}
          >

               {/* Header */}
               <div className="d-flex align-items-center">
                    <img
                         className='rounded me-3'
                         src=   { `https://admin.siliconmindstechnologies.com`  + internship.cover_url}
                         alt={internship.cover_url + " logo"}
                         width="100"
                         height="50"
                    />

                    <div>
                         <h5 className='mb-1'>{internship.title}</h5>
                         <p className="small mb-1" style={{color:"#474c56"}}>{internship.company_name}</p>

                         {hasCategory && (
                              <Chip
                                   label={internship.category[0]}
                                   size="small"
                                   color="success"
                                   variant="outlined"
                              />
                         )}
                    </div>
               </div>

               <hr />

               {/* Details */}
               <div className="row medium-text" style={{color:"#474c56"}}>

                    <div className="col-md-4 col-6 mb-3">
                         Location📍: {internship.mode}
                    </div>

                    <div className="col-md-4 col-6 mb-3">
                         Price💰: {PriceFormat(internship.stipend)}/-
                    </div>

                    <div className="col-md-4 col-6 mb-3">
                         Duration⏳: {internship.duration} Months
                    </div>

                    {/* <div className="col-md-3 col-6 mb-2">
                         👥 {internship.openings} Openings
                    </div> */}

               </div>

               <div className="d-flex justify-content-between align-items-center mt-3">

                    <p className="text-danger small mb-0">
                         {/* Apply by {internship.apply_by} */}
                    </p>

                    <Link
                         to={"/internship/" + internship.id}
                         className="btn btn-sm rounded-pill px-4 btn-siloconMinds-orng"
                    >
                         View Details
                    </Link>

               </div>

          </div>
     )
}

export default InternshipItem
